
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzePunteggiEditorDialog extends Serenity.Extensions.GridEditorDialog<ProdottiEsperienzePunteggiRow> {
        protected getFormKey() { return ProdottiEsperienzePunteggiForm.formKey; }
        protected getLocalTextPrefix() { return ProdottiEsperienzePunteggiRow.localTextPrefix; }

        protected form = new ProdottiEsperienzePunteggiForm(this.idPrefix);

    }
}